import { Outlet, useSearchParams } from "react-router-dom";
import CandidatShow from "../../components/Candidat/CandidatShow";
import ChoseGarant from "../../components/Candidat/ChoseGarant";
import { useModal } from "../../hooks/use-modal.jsx";
import { useState } from "react";
import { usePublicProperty } from "../../hooks/use-properties";

export default function CandidatShowPage() {
  const [ModalChoseGarant, closeModalChoseGarant, openModalChoseGarant] =
    useModal();
  const [profileToGarantee, setProfileToGarantee] = useState();

  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("bien");
  const { property } = usePublicProperty(propertyId);

  return (
    <>
      <ModalChoseGarant>
        <ChoseGarant
          profileId={profileToGarantee}
          closeModalChoseGarant={closeModalChoseGarant}
          propertyId={property?.id}
        />
      </ModalChoseGarant>
      <CandidatShow property={property} />
      <Outlet
        context={{
          onProfileSubmitted: (profileId, isCandidat) => {
            if (isCandidat) {
              setProfileToGarantee(profileId);
              openModalChoseGarant();
            }
          },
        }}
      />
    </>
  );
}
